import { Injectable } from '@angular/core';
import { AuthService, GlobalMessageService, WindowRef } from '@spartacus/core';
import { LoginFormComponentService } from '@spartacus/user/account/components';

@Injectable()
export class CustomLoginFormComponentService extends LoginFormComponentService {
  constructor(
    auth: AuthService,
    globalMessage: GlobalMessageService,
    winRef: WindowRef
  ) {
    super(auth, globalMessage, winRef);

    const userIdControl = this.form.get('userId');
    if (userIdControl) {
      userIdControl.clearValidators();
      userIdControl.updateValueAndValidity({ emitEvent: false });
    }
  }
}
